<template lang="html">
  <div v-if="showNotice" class="notice">
    <div class="notice-content" :style="style">
      <slot />
    </div>
    <img v-if="closeBtn" class="notice-close" @click="close" src="../assets/icons/notice-close.png" alt="">
  </div>
</template>

<script>
  import { StyleTransfer } from "../lib/styleTransfer";
  const styleTransfer = new StyleTransfer(750, 10)
  export default {
    name: 'Notice',
    data() {
      return {
        showNotice: false
      }
    },
    props: {
      closeBtn: {
        type: Boolean,
        default: false
      },
      width: [String, Number],
      transparent: {
        type: Boolean,
        default: false
      },
      unit: {
        type: String,
        default: 'rem'
      },
    },
    computed: {
      style () {
        const result = {}
        styleTransfer.parseStyle(result, this.height, 'height', this.unit)
        styleTransfer.parseStyle(result, this.height, 'line-height', this.unit)
        styleTransfer.parseStyle(result, this.width, 'width', this.unit)
        styleTransfer.parseStyle(result, this.fontSize, 'font-size', this.unit)
        if (this.inlineBlock) {
          result.display = 'inline-block'
        }
        if (this.round) {
          styleTransfer.parseStyle(result, this.height / 2, 'border-radius', this.unit)
        }
        if (this.transparent) {
          result.backgroundColor = 'transparent'
        }
        return result
      },
    },
    methods: {
      show() {
        this.showNotice = true
      },
      close() {
        this.showNotice = false
        try {
          this.$emit('closeBubble')
        } catch (e) {
          console.log(e)
        }
      }
    },
  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../style/main";
  .notice {
    width: 100%;
    height: 100vh;
    text-align: center;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(#000, 0.5);
    z-index: 999999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &-content {
      width: 80%;
      /*margin: auto;*/
      background-color: #fff;
      border-radius: use(4);
    }
    &-close {
      width: use(80);
      margin: use(34) auto;
    }
  }
</style>
